<template>
    <v-dialog :value="value" @input="toggleModal" max-width="1000px" persistent>
        <v-card>
            <v-toolbar text
                       color="abadPrimary"
                       dark>
                <v-toolbar-title>Ingresa la dirección</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleModal()">
                    <v-icon>
                        clear
                    </v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-row>
                            <v-col cols="12"><p><span style="font-weight: bold">Ejemplo:</span> CL 7A SUR #428 OESTE 70</p></v-col>
                            <v-col cols="12"><p>Los campos que no cuentan con opción desplegable, debes llenarlos con los números de la dirección.</p></v-col>

                            <v-form v-model="valid" ref="formDirecciones" lazy-validation>
                                <v-row>
                                    <v-col class="pa-2" cols="12" sm="4" >
                                        <v-autocomplete clearable
                                                        autocomplete
                                                        v-model="tipoDireccion"
                                                        :items="tipoDireccionItems"
                                                        item-text="label"
                                                        item-value="value"
                                                        :rules="[rules.required]"
                                                        label="Seleccione">
                                        </v-autocomplete>
                                    </v-col>

                                    <v-col class="pa-2" cols="12" sm="2" >
                                        <v-text-field label="#"
                                                      type="number"
                                                      v-model="num1"
                                                      :rules="[rules.required]"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col class="pa-2" cols="12" sm="3" >
                                        <v-autocomplete clearable
                                                        v-model="literal1"
                                                        :items="literalesItems"
                                                        item-text="label"
                                                        item-value="value"
                                                        label="Seleccione">
                                        </v-autocomplete>
                                    </v-col>

                                    <v-col class="pa-2" cols="12" sm="3" >
                                        <v-autocomplete clearable
                                                        autocomplete
                                                        v-model="cardinal1"
                                                        :items="puntosCardinalesItems"
                                                        item-text="label"
                                                        item-value="value"
                                                        label="Seleccione">
                                        </v-autocomplete>
                                    </v-col>

                                    <v-col class="pa-2" cols="12" sm="2" >
                                        <v-text-field v-model="num2"
                                                      type="number"
                                                      label="#"
                                                      :rules="[rules.required]">
                                        </v-text-field>
                                    </v-col>

                                    <v-col class="pa-2" cols="12" sm="3" >
                                        <v-autocomplete clearable
                                                        v-model="literal2"
                                                        :items="literalesItems"
                                                        item-text="label"
                                                        item-value="value"
                                                        label="Seleccione">
                                        </v-autocomplete>
                                    </v-col>

                                    <v-col class="pa-2" cols="12" sm="2" >
                                        <v-text-field v-model="num3"
                                                      label="#"
                                                      type="number">
                                        </v-text-field>
                                    </v-col>

                                    <v-col class="pa-2" cols="12" sm="3" >
                                        <v-autocomplete clearable
                                                        v-model="cardinal2"
                                                        :items="puntosCardinalesItems"
                                                        item-text="label"
                                                        item-value="value"
                                                        label="Seleccione">
                                        </v-autocomplete>
                                    </v-col>

                                    <v-col class="pa-2" cols="12" sm="2" >
                                        <v-text-field v-model="num4"
                                                      label="#"
                                                      type="number"
                                                      :rules="[rules.required]">
                                        </v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col class="pa-2" cols="12" >
                                        <v-textarea v-model="informacionAdicional"
                                                    name="input-7-1"
                                                    label="Información adicional"
                                                    rows="2">
                                        </v-textarea>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-row>

                        <v-row>
                            <v-col class="text-center" cols="12" >
                                <p class="text-h6 pa-2 abadPrimary--text font-weight-bold" :class="[!tipoDireccion || !num1 || !num2 || !num4 ? 'error--text' : '']">{{direccionTemporal}}</p>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text
                       color="red"
                       @click="cancel()">
                    Cancelar
                </v-btn>

                <v-btn color="abadPrimary"
                       @click="submit()">
                    Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import rules from '@/libs/rules'
export default {
  computed: {
    direccionTemporal () {
      let direccionTemporal = ''

      if (this.tipoDireccion) direccionTemporal += this.tipoDireccion

      if (this.num1) direccionTemporal += ` ${this.num1}`

      if (this.literal1) direccionTemporal += this.literal1

      if (this.cardinal1) direccionTemporal += ` ${this.cardinal1}`

      if (this.num2) direccionTemporal += ` #${this.num2}`

      if (this.literal2) direccionTemporal += this.literal2

      if (this.num3) direccionTemporal += ` ${this.num3}`

      if (this.cardinal2) direccionTemporal += ` ${this.cardinal2}`

      if (this.num4) direccionTemporal += ` - ${this.num4}`

      if (this.informacionAdicional) direccionTemporal += ` ${this.informacionAdicional}`

      return direccionTemporal
    }
  },
  data: () => ({
    tipoDireccion: '',
    num1: '',
    cardinal1: '',
    literal1: '',
    num2: '',
    literal2: '',
    num3: '',
    cardinal2: '',
    num4: '',
    informacionAdicional: '',
    literalesItems: [
      { label: 'A', value: 'A' },
      { label: 'AA', value: 'AA' },
      { label: 'AB', value: 'AB' },
      { label: 'AC', value: 'AC' },
      { label: 'AD', value: 'AD' },
      { label: 'AE', value: 'AE' },
      { label: 'AF', value: 'AF' },
      { label: 'AG', value: 'AG' },
      { label: 'AH', value: 'AH' },
      { label: 'B', value: 'B' },
      { label: 'BB', value: 'BB' },
      { label: 'BA', value: 'BA' },
      { label: 'BC', value: 'BC' },
      { label: 'BD', value: 'BD' },
      { label: 'BE', value: 'BE' },
      { label: 'BF', value: 'BF' },
      { label: 'BG', value: 'BG' },
      { label: 'BH', value: 'BH' },
      { label: 'C', value: 'C' },
      { label: 'CC', value: 'CC' },
      { label: 'CA', value: 'CA' },
      { label: 'CB', value: 'CB' },
      { label: 'CD', value: 'CD' },
      { label: 'CE', value: 'CE' },
      { label: 'CF', value: 'CF' },
      { label: 'CG', value: 'CG' },
      { label: 'CH', value: 'CH' },
      { label: 'D', value: 'D' },
      { label: 'DD', value: 'DD' },
      { label: 'DA', value: 'DA' },
      { label: 'DB', value: 'DB' },
      { label: 'DC', value: 'DC' },
      { label: 'DE', value: 'DE' },
      { label: 'DF', value: 'DF' },
      { label: 'DG', value: 'DG' },
      { label: 'DH', value: 'DH' },
      { label: 'E', value: 'E' },
      { label: 'EE', value: 'EE' },
      { label: 'EA', value: 'EA' },
      { label: 'EB', value: 'EB' },
      { label: 'EC', value: 'EC' },
      { label: 'ED', value: 'ED' },
      { label: 'EF', value: 'EF' },
      { label: 'EG', value: 'EG' },
      { label: 'EH', value: 'EH' },
      { label: 'F', value: 'F' },
      { label: 'FF', value: 'FF' },
      { label: 'FA', value: 'FA' },
      { label: 'FB', value: 'FB' },
      { label: 'FC', value: 'FC' },
      { label: 'FD', value: 'FD' },
      { label: 'FG', value: 'FG' },
      { label: 'FH', value: 'FH' },
      { label: 'G', value: 'G' },
      { label: 'GG', value: 'GG' },
      { label: 'GA', value: 'GA' },
      { label: 'GB', value: 'GB' },
      { label: 'GC', value: 'GC' },
      { label: 'GD', value: 'GD' },
      { label: 'GE', value: 'GE' },
      { label: 'GF', value: 'GF' },
      { label: 'GH', value: 'GH' },
      { label: 'H', value: 'H' },
      { label: 'HH', value: 'HH' },
      { label: 'HA', value: 'HA' },
      { label: 'HB', value: 'HB' },
      { label: 'HC', value: 'HC' },
      { label: 'HD', value: 'HD' },
      { label: 'HE', value: 'HE' },
      { label: 'HF', value: 'HF' },
      { label: 'HG', value: 'HG' }
    ],
    puntosCardinalesItems: [
      { label: 'Norte', value: 'NORTE' },
      { label: 'Sur', value: 'SUR' },
      { label: 'Este', value: 'ESTE' },
      { label: 'Oeste', value: 'OESTE' }
    ],
    rules,
    tipoDireccionItems: [
      { label: 'CARRETERA', value: 'CRT' },
      { label: 'CIRCUNVALAR', value: 'CIRCUNVALAR' },
      { label: 'MANGA', value: 'MANGA' },
      { label: 'KILÓMETRO', value: 'FM' },
      { label: 'FINCA', value: 'FCA' },
      { label: 'MANZANA', value: 'MZ' },
      { label: 'VEREDA', value: 'VDA' },
      { label: 'VÍA', value: 'VIA' },
      { label: 'HACIENDA', value: 'HDA' },
      { label: 'CORREGIMIENTO', value: 'CTGO' },
      { label: 'AEROPUERTO', value: 'AER' },
      { label: 'CALLE', value: 'CL' },
      { label: 'CARRERA', value: 'CRA' },
      { label: 'AVENIDA', value: 'AV' },
      { label: 'AVENIDA CARRERA', value: 'AK' },
      { label: 'AVENIDA CALLE', value: 'AC' },
      { label: 'AUTOPISTA', value: 'AU' },
      { label: 'DIAGONAL', value: 'DG' },
      { label: 'TRANSVERSAL', value: 'TV' },
      { label: 'ANILLO VIAL', value: 'AVIAL' },
      { label: 'CIRCULAR', value: 'CIR' },
      { label: 'CALLEJON', value: 'CLJ' }
    ],
    valid: true
  }),
  methods: {
    submit () {
      if (!this.$refs.formDirecciones.validate()) return

      this.$emit('updateAddress', this.direccionTemporal)
      this.toggleModal()
    },
    toggleModal () {
      this.$emit('input', false)
    },
    cancel () {
      this.$refs.formDirecciones.reset()
      this.toggleModal()
    }
  },
  props: ['direccion', 'value']
}
</script>
